import { c as _c } from "react/compiler-runtime";
import { useMutation } from '@apollo/client/react';
import { UPSERT_SCO_PITCH_DECK_AUDIT_SLIDE_MUTATION } from '@src/components/sco/PitchDeckAuditor/gql/operations';
import { UpsertScoPitchDeckAuditSlideInput } from '@src/graphql-types';
import { useCallback } from 'react';

/**
 * Accept or clear a suggested rewrite on an audit slide.
 * The back-end stamps acceptedAt/acceptedByUserId and refreshes the slide's chat context.
 */
export function useAcceptRewrite() {
  const $ = _c(9);
  const [mutate, mutation] = useMutation(UPSERT_SCO_PITCH_DECK_AUDIT_SLIDE_MUTATION);
  let t0;
  if ($[0] !== mutate) {
    t0 = (pitchDeckAuditSlideId, acceptedRewrite) => {
      const input = {
        pitchDeckAuditSlideId,
        acceptedRewrite
      };
      return mutate({
        variables: {
          input
        }
      });
    };
    $[0] = mutate;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const acceptRewrite = t0;
  let t1;
  if ($[2] !== mutate) {
    t1 = pitchDeckAuditSlideId_0 => {
      const input_0 = {
        pitchDeckAuditSlideId: pitchDeckAuditSlideId_0,
        clearAcceptedRewrite: true
      };
      return mutate({
        variables: {
          input: input_0
        }
      });
    };
    $[2] = mutate;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const clearRewrite = t1;
  let t2;
  if ($[4] !== acceptRewrite || $[5] !== clearRewrite || $[6] !== mutation.error || $[7] !== mutation.loading) {
    t2 = {
      acceptRewrite,
      clearRewrite,
      loading: mutation.loading,
      error: mutation.error
    };
    $[4] = acceptRewrite;
    $[5] = clearRewrite;
    $[6] = mutation.error;
    $[7] = mutation.loading;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}